import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom';

class Breadcrumb extends Component {
    render() {
        return (
            <div className="p-3 bg-light">
                <div className="container">
                    <ol class="list-inline m-0">
                        { this.props.items.map((item) => (
                             <li className="list-inline-item">/ <Link to={item.link}>{item.name}</Link></li>
                        )) }
                    </ol>
                </div>
            </div>
        )
    }
}

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/reference/ui/Breadcrumb.js